exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._9U2mauJSXOBWEx7TASvfK{font-size:14px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._9U2mauJSXOBWEx7TASvfK{margin-top:0}", ""]);
// Exports
exports.locals = {
	"description": "_9U2mauJSXOBWEx7TASvfK"
};